export default () => {
    // submenu auto wrapping
    const subMenus = document.querySelectorAll('.main-nav-menu .sub-menu');
    subMenus.forEach(menu => {
        const viewportWidth = window.innerWidth;
        const menuRect = menu.getBoundingClientRect();

        // Calculate the total width of the submenu
        const submenuWidth = menuRect.width;
        const submenuLeft = menuRect.left + window.scrollX;
        const submenuRight = submenuLeft + submenuWidth;

        // Check if the submenu overflows the viewport
        if (submenuRight > viewportWidth) {
            menu.classList.add('position-left'); // Add class to open to the left
        } else {
            menu.classList.remove('position-left'); // Ensure the class is removed if not needed
        }

        if (submenuLeft < 0) {
            menu.classList.add('position-right'); // Add class to open to the right
        } else {
            menu.classList.remove('position-right'); // Ensure the class is removed if not needed
        }

        const items = menu.querySelectorAll('li');
        let needsWrapping = false;

        // Get computed styles for padding and border
        const style = window.getComputedStyle(menu);
        const paddingLeft = parseFloat(style.paddingLeft);
        const paddingRight = parseFloat(style.paddingRight);
        const borderLeftWidth = parseFloat(style.borderLeftWidth);
        const borderRightWidth = parseFloat(style.borderRightWidth);
        const maxWidth = parseFloat(style.maxWidth) - paddingLeft - paddingRight - borderLeftWidth - borderRightWidth;

        items.forEach(item => {
            const itemWidth = item.offsetWidth;

            if (itemWidth > maxWidth || itemWidth == maxWidth) {
                needsWrapping = true;
            }
        });

        if (needsWrapping) {
            menu.classList.add('wrap-text'); // Add class to handle wrapping
        }
    });

    // mobile menu auto wrapping
    function checkIfMobileMenuIsNeeded() {
        var already_enabled_mobile_menu = false;
        var navigation_holders = document.querySelectorAll('.nav-holder');
        if (navigation_holders) {

            navigation_holders.forEach(navHolder => {
                if (already_enabled_mobile_menu) {
                    return;
                }
                const menuItems = navHolder.querySelectorAll('.menu > li');

                // Temporarily show the navHolder to measure its size
                const originalDisplay = navHolder.style.display;
                navHolder.style.display = 'block';  // Ensure it's visible but not affecting layout
            
                // Function to calculate the total height including margins
                const getFullHeightWithMargins = (element) => {
                    const style = getComputedStyle(element);
                    const marginTop = parseFloat(style.marginTop);
                    const marginBottom = parseFloat(style.marginBottom);
                    const totalHeight = element.offsetHeight + marginTop + marginBottom;
                    return totalHeight;
                };
            
                // Find the tallest menu item including margins
                let maxMenuItemHeight = 0;
                menuItems.forEach(item => {
                    const fullHeight = getFullHeightWithMargins(item);
                    if (fullHeight > maxMenuItemHeight) {
                        maxMenuItemHeight = fullHeight;
                    }
                });
            
                const navHolderHeight = navHolder.offsetHeight;
            
                // Restore the original display value
                navHolder.style.display = originalDisplay;
            
                // Perform your logic using the tallest menu item including margins
                if (navHolderHeight !== maxMenuItemHeight) {
                    document.body.classList.add('early-mobile-menu');
                    already_enabled_mobile_menu = true;
                } else {
                    document.body.classList.remove('early-mobile-menu');
                    if (document.body.classList.contains("menu-open")) {
                        document.body.classList.remove("menu-open");
                    }
                }
            });
        }
    }    

    function debounce(func, delay) {
        let timeout;
        return function(...args) {
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(this, args), delay);
        };
    }

    function onLoadCalculateFakeHeader() {
        const header = document.querySelector('header.navigation');
        const fakeHeader = document.querySelector('.fake-header');
        if (fakeHeader && header) {
            fakeHeader.style.height = header.offsetHeight + 'px';	
        }
    }
    onLoadCalculateFakeHeader();

    checkIfMobileMenuIsNeeded();
    const debouncedMobileCheck = debounce(checkIfMobileMenuIsNeeded, 300); // define before use
    window.addEventListener('resize', function(event){
        debouncedMobileCheck();
    });

    if (document.body.classList.contains('fixed-header')) {
        const fixedTransparent = document.querySelector('header.navigation');
        const scrolledBG = fixedTransparent.getAttribute('scrolled-classes');
        const NonscrolledBG = fixedTransparent.getAttribute('non-scrolled-classes');
        if (fixedTransparent) {
            // Listen to the window scroll event
            window.addEventListener('scroll', function() {
            // Get the scroll position
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            // If scrolled more than 200px, add the 'bg-white' class
            if (scrollTop > 200) {
                fixedTransparent.classList.add('scrolled');

                if (scrolledBG !== NonscrolledBG) {
                    fixedTransparent.classList.add(scrolledBG);
                    // Remove basic bg and add scrolled BG
                    fixedTransparent.classList.forEach(className => {
                        if (className.startsWith('bg-') && className !== scrolledBG) {
                            fixedTransparent.classList.remove(className); // Remove the class if it starts with "bg-" and is not scrolledBG
                        }
                    });
                }
            } else {
                fixedTransparent.classList.remove('scrolled');

                if (scrolledBG !== NonscrolledBG) {
                    fixedTransparent.classList.add(NonscrolledBG);
                    // Remove scrolled bg and add normal BG
                    fixedTransparent.classList.forEach(className => {
                        if (className.startsWith('bg-') && className == scrolledBG && scrolledBG != NonscrolledBG) {
                            fixedTransparent.classList.remove(scrolledBG); // Remove the class if it starts with "bg-" and is not scrolledBG
                        }
                    });
                }
            }
            });
        }
    }
};